import React, { useState } from "react";
import "./Vaccination.scss";
import HeroImg from "../Components/Layouts/HeroImg";

const Vaccination = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [selectedVaccine, setSelectedVaccine] = useState(null);
  
  const vaccines = [
    {
      id: 1,
      name: "Rabies Vaccine",
      description: "Essential vaccine to prevent rabies in pets.",
      dosage: "Once per year",
      benefits: ["Prevents rabies", "Required by law", "Ensures pet safety"],
      price: "$30",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 2,
      name: "Canine Distemper Vaccine",
      description: "Prevents canine distemper, a deadly virus.",
      dosage: "Initial dose + Booster after 1 month",
      benefits: ["Protects against distemper", "Strengthens immunity"],
      price: "$25",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 3,
      name: "Feline Leukemia Vaccine",
      description: "Essential vaccine against feline leukemia virus.",
      dosage: "Two doses, 3-4 weeks apart",
      benefits: ["Prevents leukemia virus", "Boosts immunity"],
      price: "$28",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 4,
      name: "Parvovirus Vaccine",
      description: "Protects against the deadly parvovirus in dogs.",
      dosage: "Three doses, 3 weeks apart",
      benefits: ["Prevents parvovirus", "Strengthens digestive health"],
      price: "$35",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 5,
      name: "Bordetella Vaccine",
      description: "Prevents kennel cough, a contagious illness.",
      dosage: "Annually or every 6 months for high-risk dogs",
      benefits: [
        "Protects against kennel cough",
        "Essential for boarding and daycare",
      ],
      price: "$20",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 6,
      name: "Leptospirosis Vaccine",
      description: "Protects pets from bacterial infection.",
      dosage: "Two doses, 3-4 weeks apart, then annually",
      benefits: [
        "Prevents leptospirosis infection",
        "Protects kidneys and liver",
      ],
      price: "$32",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 7,
      name: "Lyme Disease Vaccine",
      description: "Prevents Lyme disease caused by tick bites.",
      dosage: "Two doses, 2-4 weeks apart, then annually",
      benefits: [
        "Reduces the risk of Lyme disease",
        "Provides extra protection for outdoor pets",
      ],
      price: "$40",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 8,
      name: "Coronavirus Vaccine",
      description: "Protects against canine coronavirus infection.",
      dosage: "Two doses, 2-4 weeks apart, then annually",
      benefits: [
        "Prevents canine coronavirus infection",
        "Boosts immune defense against viral diseases",
      ],
      price: "$22",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 9,
      name: "FVRCP Vaccine",
      description: "Essential combination vaccine for cats.",
      dosage: "Initial dose + Booster after 3-4 weeks",
      benefits: [
        "Prevents feline viral rhinotracheitis, calicivirus, and panleukopenia",
        "Supports feline immune system",
      ],
      price: "$29",
      imgSrc: "/vaccination.jpeg",
    },
    {
      id: 10,
      name: "Canine Influenza Vaccine",
      description: "Protects dogs from highly contagious canine flu.",
      dosage: "Two doses, 2-4 weeks apart, then annually",
      benefits: [
        "Reduces symptoms and severity of canine influenza",
        "Essential for social or boarding dogs",
      ],
      price: "$38",
      imgSrc: "/vaccination.jpeg",
    },
  ];
  

  return (
    <>
      <HeroImg heading="Vaccination Services" text= "Our Services/vaccination"/>
      <div className="vaccination-grid">
        {vaccines.map((vaccine) => (
          <div key={vaccine.id} className="vaccine-card">
            <img src={vaccine.imgSrc} alt={vaccine.name} />
            <h2>{vaccine.name}</h2>
            <p>{vaccine.description}</p>
            <p className="price">{vaccine.price}</p>
            <button
              onClick={() => {
              setSelectedVaccine(vaccine);
              setIsModalOpen(true);
              }} // Open the modal
              className="view-details"
            >
              View Details
            </button>
          </div>
        ))}
      </div>

      {isModalOpen && (
        <div className="service-overlay active" onClick={() => setIsModalOpen(false)}>
          <div className="service-modal active" onClick={(e) => e.stopPropagation()}>
          <div className="modal-content">
            <span 
            className="close-modal" 
            onClick={() => {
              setSelectedVaccine(null);
              setIsModalOpen(false);
            }}  
            >
              &times;
            </span>
            <img src={selectedVaccine.imgSrc} alt={selectedVaccine.name} />
            <h2>{selectedVaccine.name}</h2>
            <p><strong>Description:</strong> {selectedVaccine.description}</p>
            <p><strong>Dosage:</strong> {selectedVaccine.dosage}</p>
            <ul>
              <strong>Benefits:</strong>
              {selectedVaccine.benefits.map((benefit, index) => (
                <li key={index}>{benefit}</li>
              ))}
            </ul>
            <p className="price">{selectedVaccine.price}</p>
            <button className="book-now" onClick={() => alert('Booking confirmed!')}>Book Now</button>
          </div>
        </div>
        </div>
      )}
    
    </>
  );
};

export default Vaccination;
